<template>
  <div>
    <h4 class="mt-3 mb-2">
      {{
        $t(
          'After sending this conversation, if there is no response from customers. The system will send messages to follow up them within 24 hours.'
        )
      }}
    </h4>
    <h4 class="mb-2" v-if="isCommentToInbox">
      {{ $t(`If user haven't sent message in inbox ,The follow-up message won't be sent`) }}
    </h4>
    <template>
      <div class="form-control" style="display: flow-root;">
        <toggle-button
          v-model="intent.follow_up_status"
          :sync="true"
          :color="$vuetify.theme.success"
          :labels="{ checked: 'ON', unchecked: 'OFF' }"
          style="display: inline-block"
        />
        {{ $t('Turn on follow up feature') }}
      </div>
    </template>
    <v-layout class="mt-4">
      <v-flex
        v-if="showMultipleChannel"
        class="channel"
        shrink
        style="border-right: 1px solid #eee"
      >
        <div v-if="!isCommentToInbox">
          <template v-for="(item, index) in channelItem">
            <div
              v-if="item.name != 'whatsapp'"
              :key="index"
              :class="{ 'primary white--text': tab2 == item.tab }"
              @click="tab2 = item.tab"
              class="py-1 pl-2 pr-2"
              style="
                      border: 1px solid #eee;
                      border-width: 1px 0px 1px 1px;
                      border-top-left-radius: 5px;
                      border-bottom-left-radius: 5px;
                      cursor: pointer;
                    "
            >
              <span :class="`fab ${item.icon}`"></span>
            </div>
          </template>
        </div>
        <div v-else>
          <div
            v-if="fb_status"
            :class="{ 'primary white--text': tab2 == 'facebook' }"
            @click="tab2 = 'facebook'"
            class="py-1 pl-2 pr-2"
            style="
                    border: 1px solid #eee;
                    border-width: 1px 0px 1px 1px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    cursor: pointer;
                  "
          >
            <span class="fab fa-facebook"></span>
          </div>
          <div
            :class="{ 'primary white--text': tab2 == 'line' }"
            @click="tab2 = 'line'"
            v-if="!isCommentToInbox && line_status"
            class="py-1 pl-2 pr-2"
            style="
                    border: 1px solid #eee;
                    border-width: 1px 0px 1px 1px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    cursor: pointer;
                  "
          >
            <span class="fab fa-line"></span>
          </div>
          <div
            v-if="ig_status"
            :class="{ 'primary white--text': tab2 == 'instagram' }"
            @click="tab2 = 'instagram'"
            class="py-1 pl-2 pr-2"
            style="
                    border: 1px solid #eee;
                    border-width: 1px 0px 1px 1px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    cursor: pointer;
                  "
          >
            <span class="fab fa-instagram"></span>
          </div>
          <div
            :class="{ 'primary white--text': tab2 == 'google' }"
            @click="tab2 = 'google'"
            v-if="google_status && !isCommentToInbox"
            class="py-1 pl-2 pr-2"
            style="
                    border: 1px solid #eee;
                    border-width: 1px 0px 1px 1px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    cursor: pointer;
                  "
          >
            <span class="fab fa-google"></span>
          </div>
        </div>
      </v-flex>
      <v-flex :key="`follow_up_${timestamp}`">
        <template v-if="!showMultipleChannelFollowUp">
          <template v-if="(isReplyComment && isCommentToInbox) || isLiveStream">
            <intent-group
              :key="`follow_up_group_${timestamp}`"
              :id="`follow_up_group_${timestamp}`"
              :showMultipleChannel="showMultipleChannelFollowUp"
              v-model="messages2"
              :availableBubbles="['text', 'image', 'button']"
              :followUp="true"
              @changeSetting="changeSettingFollowUp"
            ></intent-group>
          </template>
          <intent-group
            v-else
            :key="`follow_up_group_2${timestamp}`"
            :id="`follow_up_group_2${timestamp}`"
            :showMultipleChannel="showMultipleChannelFollowUp"
            v-model="messages2"
            :availableBubbles="['text', 'image', 'button']"
            :followUp="true"
            @changeSetting="changeSettingFollowUp"
          ></intent-group>
        </template>
        <template v-else>
          <template v-if="tab2 == 'facebook'">
            <keep-alive>
              <intent-group
                key="fb_message"
                v-model="fb_messages"
                :showMultipleChannel="showMultipleChannelFollowUp"
                :channel="tab2"
                @changeSetting="changeSettingFollowUp"
                :availableBubbles="['text', 'image', 'button']"
                :followUp="true"
              ></intent-group>
            </keep-alive>
          </template>
          <template v-else-if="tab2 == 'line'">
            <keep-alive>
              <intent-group
                key="line_message"
                v-model="line_messages"
                :showMultipleChannel="showMultipleChannelFollowUp"
                @changeSetting="changeSettingFollowUp"
                :channel="tab2"
                :availableBubbles="['text', 'image', 'button']"
                :followUp="true"
              ></intent-group>
            </keep-alive>
          </template>
          <template v-else-if="tab2 == 'instagram'">
            <keep-alive>
              <intent-group
                key="ig_message"
                v-model="ig_messages"
                :showMultipleChannel="showMultipleChannelFollowUp"
                @changeSetting="changeSettingFollowUp"
                :channel="tab2"
                :availableBubbles="['text', 'image', 'button']"
                :followUp="true"
              ></intent-group>
            </keep-alive>
          </template>
          <template v-else-if="tab2 == 'whatsapp'">
            <keep-alive>
              <intent-group
                key="whatsapp_message"
                v-model="whatsapp_messages"
                :showMultipleChannel="showMultipleChannelFollowUp"
                @changeSetting="changeSettingFollowUp"
                :channel="tab2"
                :availableBubbles="['text', 'image', 'button']"
                :followUp="true"
              ></intent-group>
            </keep-alive>
          </template>
          <template v-else-if="tab2 == 'google'">
            <keep-alive>
              <intent-group
                key="google_message"
                v-model="google_messages"
                :showMultipleChannel="showMultipleChannelFollowUp"
                @changeSetting="changeSettingFollowUp"
                :channel="tab2"
                :availableBubbles="['text', 'image', 'button']"
                :followUp="true"
              ></intent-group>
            </keep-alive>
          </template>
        </template>

        <div v-if="tab2 !== 'whatsapp'">
          <div class="small pl-3" style="margin-top: 10px">{{ $t('Choice') }}</div>
          <div class="mb-3"></div>

          <template v-if="!showMultipleChannelFollowUp">
            <div
              class="form-control pl-3"
              :class="{ 'has-error': errorTag['follow_up_replies'].length > 0 }"
            >
              <tags
                v-model="follow_up_reply"
                :tags="follow_up_replies"
                @tags-changed="followUpAddReplies('follow_up_replies', $event)"
                @before-adding-tag="checkQuickReply('follow_up_replies', $event)"
                style="margin-bottom: 5px"
                :btnText="$t('Add choice')"
              ></tags>
            </div>
          </template>
          <template v-else>
            <div
              class="form-control pl-3"
              :class="{ 'has-error': errorTag[`follow_up_${tab2}`].length > 0 }"
            >
              <tags
                v-model="follow_up_reply"
                :tags="
                  tab2 == 'facebook'
                    ? follow_up_fb_replies
                    : tab2 == 'line'
                    ? follow_up_line_replies
                    : tab2 == 'instagram'
                    ? follow_up_ig_replies
                    : tab2 == 'whatsapp'
                    ? follow_up_whatsapp_replies
                    : follow_up_google_replies
                "
                @tags-changed="followUpAddReplies(tab2, $event)"
                @before-adding-tag="checkQuickReply(`follow_up_${tab2}`, $event)"
                style="margin-bottom: 5px"
                :btnText="$t('Add choice')"
              ></tags>
            </div>
          </template>
          <div class="form-control has-error">
            <template v-for="(error, errorKey) in errorTag">
              <span :key="errorKey" class="text-error" v-if="error.length > 0">
                <template v-if="error.includes('overmaxlength')">{{
                  $t('Message cannot be longer than 20 alphabets')
                }}</template>
                <template v-else-if="error.includes('overtagmax')">{{
                  $t('Choices cannot be more than 10 items')
                }}</template>
                <template v-else-if="error.includes('duplicate')">{{
                  $t('Duplicate Choice')
                }}</template>
              </span>
            </template>
          </div>
        </div>
        <div class="mt-4 pl-3">
          <div v-if="tab2 == 'line'">{{ $t('setting_followup_date_time') }}</div>
          <p v-else>{{ $t('Schedule follow up time (Hours:Minutes)') }}</p>
        </div>
        <v-layout v-show="!showMultipleChannelFollowUp && tab2 == 'all'">
          <v-flex xs12 md4 class="ma-2">
            <time-picker
              v-model="intent.follow_up_within_seconds"
              full-width
              :minRange="
                !intent.follow_up_within_seconds ||
                (intent.follow_up_within_seconds &&
                  (intent.follow_up_within_seconds.HH === '' ||
                    intent.follow_up_within_seconds.HH === '00'))
                  ? [[5, 55]]
                  : null
              "
              :minute-interval="5"
              hide-disabled-minutes
            ></time-picker>
          </v-flex>
        </v-layout>
        <v-layout
          v-show="showMultipleChannelFollowUp && tab2 != 'all'"
          style="align-items: center; "
        >
          <v-flex
            v-show="tab2 == 'line'"
            xs12
            md3
            class="grey--text text-xs-left my-2 lineFollowupText"
            ><div class="ma-2 pa-1" style="width: 100%;">
              {{ $t('customer_ignore_long_time') }}
            </div></v-flex
          >
          <v-flex
            v-show="tab2 == 'line'"
            xs12
            md4
            class="ma-2 ml-1"
            style="display: flex;justify-content: space-between;"
          >
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <div class="form-control mr-2">
                  <input
                    type="text"
                    style="max-width: 100px;min-width:80px"
                    :value="`${intent.follow_up_line_within_seconds_date || 0} (${$t('day(s)')})`"
                    v-on="on"
                  />
                </div>
              </template>
              <v-list
                style="display: flex; flex-direction: column; max-height: 200px; overflow-y: scroll;"
              >
                <v-list-item
                  v-for="(item, index) in values"
                  :key="index"
                  @click="intent.follow_up_line_within_seconds_date = item"
                  style="cursor: pointer; margin-top: 8px;"
                  class="text-xs-center line-followup"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <time-picker
              v-model="intent.follow_up_line_within_seconds"
              full-width
              :minRange="
                (!intent.follow_up_line_within_seconds ||
                  (intent.follow_up_line_within_seconds &&
                    (intent.follow_up_line_within_seconds.HH === '' ||
                      intent.follow_up_line_within_seconds.HH === '00'))) &&
                intent.follow_up_line_within_seconds_date !== 0
                  ? [[0, 55]]
                  : (!intent.follow_up_line_within_seconds ||
                      (intent.follow_up_line_within_seconds &&
                        (intent.follow_up_line_within_seconds.HH === '' ||
                          intent.follow_up_line_within_seconds.HH === '00'))) &&
                    intent.follow_up_line_within_seconds_date === 0
                  ? [[5, 55]]
                  : null
              "
              :minute-interval="5"
              hide-disabled-minutes
            ></time-picker>
          </v-flex>
          <v-flex v-show="tab2 == 'facebook'" xs12 md4 class="ma-2 pl-2">
            <time-picker
              v-model="intent.follow_up_fb_within_seconds"
              full-width
              :minRange="
                !intent.follow_up_fb_within_seconds ||
                (intent.follow_up_fb_within_seconds &&
                  (intent.follow_up_fb_within_seconds.HH === '' ||
                    intent.follow_up_fb_within_seconds.HH === '00'))
                  ? [[5, 55]]
                  : null
              "
              :minute-interval="5"
              hide-disabled-minutes
            ></time-picker>
          </v-flex>
          <v-flex v-show="tab2 == 'instagram'" xs12 md4 class="ma-2">
            <time-picker
              v-model="intent.follow_up_ig_within_seconds"
              full-width
              :minRange="
                !intent.follow_up_ig_within_seconds ||
                (intent.follow_up_ig_within_seconds &&
                  (intent.follow_up_ig_within_seconds.HH === '' ||
                    intent.follow_up_ig_within_seconds.HH === '00'))
                  ? [[5, 55]]
                  : null
              "
              :minute-interval="5"
              hide-disabled-minutes
            ></time-picker>
          </v-flex>
          <v-flex v-show="tab2 == 'google'" xs12 md4 class="ma-2 pl-2">
            <time-picker
              v-model="intent.follow_up_google_within_seconds"
              full-width
              :minRange="
                !intent.follow_up_google_within_seconds ||
                (intent.follow_up_google_within_seconds &&
                  (intent.follow_up_google_within_seconds.HH === '' ||
                    intent.follow_up_google_within_seconds.HH === '00'))
                  ? [[5, 55]]
                  : null
              "
              :minute-interval="5"
              hide-disabled-minutes
            ></time-picker>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <div class="mt-4">
      <div class="hr"></div>
      <div class="text-xs-center" style="margin: -13px">
        <a
          class="text btn-advanced"
          href="javascript:void(0);"
          @click="onShowAdvance"
          style="position: relative"
        >
          {{ $t('Advanced') }}
          <i
            class="fa"
            :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }"
          ></i>
          <!-- <v-premium-lock :inline="true"></v-premium-lock> -->
        </a>
      </div>

      <template>
        <div
          style="margin-top: 25px"
          v-show="showAdvanced || errors.has('context_in') || errors.has('startdate')"
        >
          <v-tabs v-model="advancedTab" slider-color="primary" touchless show-arrows>
            <v-tab :key="0" ripple
              >{{ $t('Customer') }}
              <a href="https://tinyurl.com/2rs9ahu7" target="blank"
                ><i
                  style="font-size: 18px; color: #ed1e79;"
                  class="ml-1 fas fa-question-circle"
                ></i></a
            ></v-tab>
            <v-tab v-if="!isCommentToInbox && !isLiveStream" :key="1" ripple
              >{{ $t('Context') }}
              <a href="https://tinyurl.com/3pbbzz54" target="blank"
                ><i
                  style="font-size: 18px; color: #ed1e79;"
                  class="ml-1 fas fa-question-circle"
                ></i></a
            ></v-tab>

            <v-tab :key="2" ripple
              >{{ $t('Line Notify') }}
              <a href="https://tinyurl.com/2p82ydvv" target="blank"
                ><i
                  style="font-size: 18px; color: #ed1e79;"
                  class="ml-1 fas fa-question-circle"
                ></i></a
            ></v-tab>

            <v-tab-item :key="0">
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div class="form-control mb-2">
                    <div class="primary--text caption">{{ $t('Status') }}</div>
                    <v-layout wrap>
                      <v-flex sm11>
                        <multiselect
                          :options="statusOptions"
                          v-model="intent.follow_up_userstatus"
                          :multiple="false"
                          :taggable="true"
                          @input="errorMaxlength = false"
                          @tag="onSelectStatus"
                        >
                        </multiselect>
                        <small style="color:red" v-if="errorMaxlength">
                          {{ $t('message_cannot_be_longer_than_25_alphabets') }}</small
                        >
                      </v-flex>
                      <v-flex sm1>
                        <v-btn samll icon @click="intent.follow_up_userstatus = null">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                  <div>
                    <div class="primary--text caption mb-1">{{ $t('Tag') }}</div>
                    <tags
                      :combobox="true"
                      v-model="usertag"
                      :tags="usertags"
                      @tags-changed="addUserTags"
                      @before-adding-tag="checkUserTags"
                      :itemOption="tagOptions"
                      style="margin-bottom: 5px"
                      :btnText="$t('Add tag')"
                    ></tags>
                    <small style="color:red" v-if="errorMaxlengthTags">
                      {{ $t('message_cannot_be_longer_than_25_alphabets') }}</small
                    >
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="!isCommentToInbox && !isLiveStream" :key="1">
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' || isCoachlab ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium' || isCoachlab"
                ></v-premium-plan-popup>
                <v-card-text>
                  <v-layout>
                    <v-flex
                      v-if="false"
                      class="form-control pr-1"
                      :class="{ 'has-error': errors.has('context_in') }"
                    >
                      <input
                        style="margin-bottom: 5px"
                        type="text"
                        class="form-control"
                        placeholder="Context In"
                        data-vv-as="Context In"
                        name="context_in"
                        v-model="intent.context_in"
                        v-validate="!isCommentToInbox ? 'excluded:comment' : ''"
                      />
                      <span class="text-error" v-show="errors.has('context_in')">{{
                        $t('Context In cannot be Comment')
                      }}</span>
                    </v-flex>
                    <v-flex class="form-control pl-1">
                      <multi-select-custom
                        v-model="intent.follow_up_context_out"
                        :options.sync="contextOptions"
                        label="label"
                        trackBy="value"
                        placeholder="Context Out"
                        :taggable="true"
                        @tag="intent.follow_up_context_out = $event"
                      >
                      </multi-select-custom>
                      <!-- <input
                        type="text"
                        class="form-control"
                        placeholder="Context Out"
                        v-model="intent.follow_up_context_out"
                      /> -->
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item :key="2">
              <v-card
                flat
                :style="{
                  'min-height': $store.getters.getPackage != 'premium' ? '250px' : ''
                }"
              >
                <v-premium-plan-popup
                  :showAll="false"
                  v-if="$store.getters.getPackage != 'premium'"
                ></v-premium-plan-popup>
                <v-card-text>
                  <div class="primary--text">
                    {{ $t('Line Notify') }}
                  </div>
                  <v-layout>
                    <v-flex xs8 class="pt-3">
                      {{ $t('Turn on/off Line Notify') }}
                    </v-flex>
                    <v-flex xs4 class="text-xs-right">
                      <template v-if="$store.state.linenotifylist.length == 0"></template>
                      <template
                        v-else-if="
                          (selectedBot.notify_intent && !isCommentToInbox) ||
                            (selectedBot.notify_comment && isCommentToInbox)
                        "
                      >
                        <toggle-button
                          class="mt-2"
                          :value="intent.follow_up_linenoti_status"
                          :sync="true"
                          :color="$vuetify.theme.success"
                          @change="toggleLineNotifyStatus"
                          :labels="{ checked: 'ON', unchecked: 'OFF' }"
                          style="display: inline-block"
                        />
                      </template>
                    </v-flex>
                  </v-layout>
                  <div class="col s12">
                    <template v-if="$store.state.linenotifylist.length == 0">
                      {{ $t('You are not connected to Line Notify.') }}
                      <router-link to="billing">{{
                        $t('Click to connected Line Notify at the settings page')
                      }}</router-link>
                    </template>
                    <template
                      v-else-if="
                        (selectedBot.notify_intent && !isCommentToInbox) ||
                          (selectedBot.notify_comment && isCommentToInbox)
                      "
                    >
                      <div class="form-control">
                        <textarea
                          class="form-control"
                          :placeholder="$t('Message')"
                          maxlength="2000"
                          v-model="intent.follow_up_linenoti_text"
                        ></textarea>
                      </div>

                      <!-- Select line notify -->
                      <div>{{ $t('Select Line Account') }}</div>
                      <v-combobox
                        style="z-index: 0;"
                        @change="selectLinenotifyUserId()"
                        v-model="selectLinenotify"
                        :items="$store.state.linenotifylist"
                        :item-text="'name'"
                        :item-value="'id'"
                        multiple
                        chips
                        outline
                        single-line
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            :key="JSON.stringify(data.item)"
                            :selected="data.selected"
                            :disabled="data.disabled"
                            class="v-chip--select-multi"
                            @input="data.parent.selectItem(data.item.adminid)"
                          >
                            <v-avatar>
                              <v-img
                                :src="
                                  `https://graph.facebook.com/${data.item.adminid}/picture?type=square&SameSite=None`
                                "
                              ></v-img>
                            </v-avatar>
                            {{ data.item.name }}
                          </v-chip>
                        </template>
                      </v-combobox>
                    </template>
                    <template v-else>
                      {{ $t('Not yet alert via Line Notify.') }}
                      <router-link to="billing">{{
                        $t('Click to connected Line Notify at the settings page')
                      }}</router-link>
                    </template>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </div>
      </template>
    </div>

    <div class="mt-4" style="margin-bottom: 15px; text-align: center;">
      <a href="javascript:void(0);" class="btn-preview" @click="showPreview2 = true">
        <i class="far fa-eye"></i>
        {{ $t('preview') }}
      </a>
      <preview-message
        v-if="showPreview2"
        @close="showPreview2 = false"
        :messages="messagesPreview"
        :choice="quickReplyPreview"
      ></preview-message>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import Tags from '@/components/elements/Tags'
import IntentGroup from './IntentGroup'
import { ToggleButton } from 'vue-js-toggle-button'
import TimePicker from '@/components/elements/TimePicker.vue'
import PreviewMessage from '@/components/elements/PreviewMessage'
import { cloneDeep } from 'lodash'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import IntentGroupItem from '../intent/IntentGroupItem.js'
import MultiSelectCustom from '../../elements/MultiSelectCustom.vue'

export default {
  props: [
    'value',
    'isCommentToInbox',
    'isReplyComment',
    'isLiveStream',
    'messages2',
    'fb_messages',
    'line_messages',
    'ig_messages',
    'google_messages',
    'whatsapp_messages',
    'statusOptions',
    'tagOptions',
    'follow_up_selectLinenotify',
    'showMultipleChannel',
    'isWelcome'
  ],
  data: function() {
    return {
      fb_messages2: this.fb_messages,
      line_messages2: this.line_messages,
      ig_messages2: this.ig_messages,
      google_messages2: this.google_messages,
      whatsapp_messages2: this.whatsapp_messages,
      usertag: '',
      advancedTab: null,
      showAdvanced: false,
      errorMaxlengthTags: false,
      errorMaxlength: false,
      intent: this.value,
      showPreview2: false,
      timestamp: dayjs().format('x'),
      tab2: 'all',
      selectLinenotify: this.follow_up_selectLinenotify,
      errorTag: {
        replies: [],
        facebook: [],
        line: [],
        ig: [],
        google: [],
        whatsapp: [],
        follow_up_facebook: [],
        follow_up_line: [],
        follow_up_ig: [],
        follow_up_google: [],
        follow_up_whatsapp: [],
        follow_up_replies: []
      },
      follow_up_reply: '',
      showMultipleChannelFollowUp: this.showMultipleChannel,
      values: [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30
      ],
      fb_status: false,
      line_status: false,
      ig_status: false,
      google_status: false,
      contextOptions: [
        {
          label: this.$t('contactadmin'),
          value: 'contactadmin'
        }
      ]
    }
  },
  components: {
    Tags,
    IntentGroup,
    ToggleButton,
    TimePicker,
    PreviewMessage,
    Multiselect,
    MultiSelectCustom
  },
  mixins: [IntentGroupItem],
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),
    quickReplyPreview: function() {
      const vm = this
      let reply = ''
      if (vm.tab2 == 'all') {
        reply = vm.follow_up_replies
      } else if (vm.tab2 == 'facebook') {
        reply = vm.follow_up_fb_replies
      } else if (vm.tab2 == 'line') {
        reply = vm.follow_up_line_replies
      } else if (vm.tab2 == 'instagram') {
        reply = vm.follow_up_ig_replies
      } else if (vm.tab2 == 'google') {
        reply = vm.follow_up_google_replies
      } else if (vm.tab2 == 'whatsapp') {
        reply = vm.follow_up_whatsapp_replies
      }
      return reply
    },
    messagesPreview: function() {
      const vm = this
      let messages = [[]]
      if (vm.tab2 == 'all') {
        messages = vm.messages2
      } else if (vm.tab2 == 'facebook') {
        messages = vm.fb_messages2
      } else if (vm.tab2 == 'line') {
        messages = vm.line_messages2
      } else if (vm.tab2 == 'instagram') {
        messages = vm.ig_messages2
      } else if (vm.tab2 == 'google') {
        messages = vm.google_messages2
      } else if (vm.tab2 == 'whatsapp') {
        messages = vm.whatsapp_messages2
      }
      return messages
    },
    follow_up_replies: {
      get() {
        let vm = this
        if (
          vm.intent &&
          vm.intent.follow_up_quick_reply &&
          vm.intent.follow_up_quick_reply !== ''
        ) {
          var quick_replies = []
          quick_replies = vm.intent.follow_up_quick_reply.split(',')

          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.intent, 'follow_up_quick_reply', result.join(','))
      }
    },
    follow_up_fb_replies: {
      get() {
        let vm = this
        if (
          vm.intent &&
          vm.intent.follow_up_fb_quick_reply &&
          vm.intent.follow_up_fb_quick_reply !== ''
        ) {
          // console.log(vm.intent.fb_quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.follow_up_fb_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.intent, 'follow_up_fb_quick_reply', result.join(','))
      }
    },
    follow_up_line_replies: {
      get() {
        let vm = this
        if (
          vm.intent &&
          vm.intent.follow_up_line_quick_reply &&
          vm.intent.follow_up_line_quick_reply !== ''
        ) {
          // console.log(vm.intent.line_quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.follow_up_line_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.intent, 'follow_up_line_quick_reply', result.join(','))
      }
    },
    follow_up_ig_replies: {
      get() {
        let vm = this
        if (
          vm.intent &&
          vm.intent.follow_up_ig_quick_reply &&
          vm.intent.follow_up_ig_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.follow_up_ig_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.intent, 'follow_up_ig_quick_reply', result.join(','))
      }
    },
    follow_up_whatsapp_replies: {
      get() {
        let vm = this
        if (
          vm.intent &&
          vm.intent.follow_up_whatsapp_quick_reply &&
          vm.intent.follow_up_whatsapp_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.follow_up_whatsapp_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        let result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        vm.$set(vm.intent, 'follow_up_whatsapp_quick_reply', result.join(','))
      }
    },
    follow_up_google_replies: {
      get() {
        const vm = this
        if (
          vm.intent &&
          vm.intent.follow_up_google_quick_reply &&
          vm.intent.follow_up_google_quick_reply !== ''
        ) {
          // console.log(vm.intent.ig_quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.follow_up_google_quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        let result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        vm.$set(vm.intent, 'follow_up_google_quick_reply', result.join(','))
      }
    },
    usertags: {
      get() {
        const vm = this
        if (vm.intent && vm.intent.follow_up_usertags && vm.intent.follow_up_usertags !== '') {
          var usertags = []

          usertags = vm.intent.follow_up_usertags.split(',')
          var result = []
          if (usertags) {
            try {
              result = usertags.map(function(tag) {
                return { text: tag }
              })
            } catch (error) {}
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        if (value) {
          result = value.map(function(tag) {
            return tag.text
          })
        }

        this.$set(this.intent, 'follow_up_usertags', result.join(','))
      }
    }
  },
  mounted() {
    const vm = this

    if (
      vm.check_privilege('multichannel') &&
      (vm.intent.follow_up_fb_val ||
        vm.intent.follow_up_line_val ||
        vm.intent.follow_up_ig_val ||
        vm.intent.follow_up_whatsapp_val)
    ) {
      vm.showMultipleChannelFollowUp = true
      vm.$emit('update:showMultipleChannel', vm.showMultipleChannelFollowUp)
      vm.tab2 = 'facebook'
    }

    vm.timestamp = dayjs().format('x')
    const packages = vm.selectedBot.packages
    vm.fb_status = packages.includes('facebook') ? true : false
    vm.line_status = packages.includes('line') ? true : false
    vm.ig_status = packages.includes('instagram') ? true : false
    vm.google_status = packages.includes('google') ? true : false
  },
  methods: {
    selectLinenotifyUserId() {
      this.$emit('update:follow_up_selectLinenotify', this.selectLinenotify)
    },
    addUserTags: function(newTags) {
      this.usertags = newTags
    },
    checkUserTags(obj) {
      this.errorUserTags = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 25) {
        this.errorUserTags.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorUserTags.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onSelectStatus(value) {
      if (value.length <= 25) {
        this.errorMaxlength = false
        this.intent.follow_up_userstatus = value
      } else {
        this.errorMaxlength = true
      }
    },
    onShowAdvance: function() {
      this.showAdvanced = !this.showAdvanced
    },
    toggleLineNotifyStatus: function() {
      this.intent.follow_up_linenoti_status = !this.intent.follow_up_linenoti_status
    },
    followUpAddReplies: function(type, newTags) {
      const vm = this
      if (type == 'facebook') vm.follow_up_fb_replies = newTags
      else if (type == 'line') vm.follow_up_line_replies = newTags
      else if (type == 'instagram') vm.follow_up_ig_replies = newTags
      else if (type == 'google') vm.follow_up_google_replies = newTags
      else if (type == 'whatsapp') vm.follow_up_google_replies = newTags
      else vm.follow_up_replies = newTags
    },
    async changeSettingFollowUp(payload) {
      const vm = this
      if (
        (vm.$store.getters.getPackage == 'premium' || vm.selectedBot.pagetype == 'enterprise') &&
        payload.hasOwnProperty('showMultipleChannel')
      ) {
        if (
          vm.showMultipleChannelFollowUp != payload.showMultipleChannel &&
          payload.showMultipleChannel == true
        ) {
          var fb_messages2 = cloneDeep(vm.messages2)
          vm.fb_messages2 = fb_messages2.map(el => {
            return el.filter(sel => {
              return !['flex', 'imagemap', 'sticker'].includes(sel.type)
            }, [])
          }, [])
          vm.line_messages2 = cloneDeep(vm.messages2)
          vm.google_messages2 = cloneDeep(vm.messages2)
          vm.whatsapp_messages2 = cloneDeep(vm.messages2)
          vm.ig_messages2 = cloneDeep(vm.messages2)
          vm.ig_messages2 = vm.ig_messages2.map(el => {
            return el.filter(sel => {
              return !['flex', 'imagemap', 'sticker'].includes(sel.type)
            }, [])
          }, [])

          vm.$set(vm.intent, 'follow_up_fb_quick_reply', vm.intent.follow_up_fb_quick_reply)
          vm.$set(vm.intent, 'follow_up_line_quick_reply', vm.intent.follow_up_line_quick_reply)
          vm.$set(vm.intent, 'follow_up_ig_quick_reply', vm.intent.follow_up_ig_quick_reply)
          vm.$set(vm.intent, 'follow_up_google_quick_reply', vm.intent.follow_up_google_quick_reply)
          vm.$set(
            vm.intent,
            'follow_up_whatsapp_quick_reply',
            vm.intent.follow_up_whatsapp_quick_reply
          )
        }
        vm.showMultipleChannelFollowUp = payload.showMultipleChannel
        vm.$emit('update:showMultipleChannel', payload.showMultipleChannel)
        if (vm.showMultipleChannelFollowUp) vm.tab2 = 'facebook'
        else vm.tab2 = 'all'
      }
    },
    checkQuickReply(type, obj) {
      const vm = this
      vm.errorTag[type] = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length > 20) {
        vm.errorTag[type].push('overmaxlength')
        obj.error()
      } else if (
        obj.type == 'add' &&
        ((type == 'follow_up_replies' && vm.follow_up_replies.length >= 10) ||
          (type == `follow_up_facebook` && vm.follow_up_fb_replies.length >= 10) ||
          (type == `follow_up_line` && vm.follow_up_line_replies.length >= 10) ||
          (type == `follow_up_ig` && vm.follow_up_ig_replies.length >= 10) ||
          (type == `follow_up_google` && vm.follow_up_google_replies.length >= 10) ||
          (type == `follow_up_whatsapp` && vm.follow_up_whatsapp_replies.length >= 10))
      ) {
        vm.errorTag[type].push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        vm.errorTag[type].push('duplicate')
        obj.error()
      } else obj.addTag()
    }
  }
}
</script>

<style scoped>
.line-followup {
  padding: 0.3em 0;
}
.line-followup:active,
.line-followup:hover,
.line-followup:focus {
  background-color: #41b883;
  color: #fff;
}
@media only screen and (max-width: 600px) {
  .lineFollowupText {
    max-width: 80px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentFollowUp.vue